import React from 'react'

export default function LeagueFormActions({
  navigate,
  isSubmitting,
  isEditMode,
}) {
  return (
    <div className="form-actions">
      <button
        type="button"
        className="btn btn-secondary"
        onClick={() => navigate('/admin/leagues-registrations')}
        data-track="admin.cancel_league_creation"
      >
        Cancel
      </button>
      <button
        type="submit"
        className="btn btn-primary"
        disabled={isSubmitting}
        data-track="admin.submit_league_form"
      >
        {isSubmitting
          ? isEditMode
            ? 'Saving...'
            : 'Creating...'
          : isEditMode
            ? 'Save Changes'
            : 'Create League'}
      </button>
    </div>
  )
}
